import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {ShowExamDialogComponent} from './show.exam.dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';


const routes =
    [{path: 'examsdialog', component: ShowExamDialogComponent}];

@NgModule({
  declarations: [ShowExamDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes), NgxChartsModule],
  exports: [ShowExamDialogComponent]
})

export class ShowExamModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/progress/exam/show.exam.dialog.module.ts